import { Injectable } from '@angular/core';
import { UniversalService } from '../universal/universal.service';

/**
 * Service for providing window to services and components.
 */
@Injectable({
  providedIn: 'root'
})
export class WindowWrapperService {
  /**
   * Toggles the return data for testing.
   */
  isTest = false;

  /**
   * Data layer mock data.
   */
  dataLayer = {
    dataLayer: {
      digitalData: {
        attributes: {
          cardBanner: {
            applicationStatus: '',
            cardType: '',
            offerId: ''
          },
          siteSearch: {
            header: '',
            page: '',
            footer: ''
          }
        }
      }
    }
  };

  /**
   * Object for mocking data.
   */
  mockWindow = {
    delta: {},
    setTimeout: () => null,
    clearTimeout: () => null,
    document: {
      querySelectorAll: () => null,
      getElementsByTagName: () => null,
      getElementById: () => null,
      createElement: () => null,
      createEvent: () => {
        return {
          initCustomEvent: () => null
        };
      },
      dispatchEvent: () => null,
      forms: [],
      cookie: '',
      body: {
        clientWidth: 1280,
        clientHeight: 720
      },
      documentElement: {
        clientWidth: 1280,
        clientHeight: 720
      }
    },
    open: () => null,
    location: {
      hostname: 'delta.com',
      origin: 'delta.com',
      href: 'delta.com/path',
      reload: () => null
    },
    localStorage: {
      getItem: () => null,
      setItem: () => null
    },
    sessionStorage: {
      getItem: () => null,
      setItem: () => null,
      removeItem: () => true
    },
    removeEventListener: () => null,
    addEventListener: () => null,
    JSON: {
      parse: () => null,
      stringify: () => null
    },
    CustomEvent: () => null,
    idp: this.dataLayer,
    screen: {
      width: 1280,
      height: 720
    },
    innerWidth: 1280,
    innerHeight: 720
  };

  /**
   * WindowWrapperService constructor.
   */
  constructor(private universal: UniversalService) {}

  /**
   * Get the current window object, or mock it.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getWindow(): Window | any {
    if (this.universal.isBrowser() && !this.isTest) {
      return window;
    }

    return this.mockWindow;
  }
}
